export default __webpack_public_path__ + "static/media/chantillymini.50c8b69d.jpg";